// Model
import RouteModel from "../model/route.model";

export function mapperToRouteModel(routeDTO) {
    return new RouteModel(routeDTO.id, routeDTO.name)
}